import React from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import Emptydata from "../common/Emptydata";
import ConstructionIcon from "@mui/icons-material/Construction";

const TradeAboutSection = ({ tradeData }) => {
  const { tradeDetails, tradeNames, relatedTradeNames } = tradeData;
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const ENGLISH = English.Trades || {};

  const LanguageData = multiLanguageData?.Trades || {};
  const {
    TEXT_NO_INFO_TRADE = ENGLISH.TEXT_NO_INFO_TRADE,
    TEXT_ALSO_KNOWN_AS = ENGLISH.TEXT_ALSO_KNOWN_AS,
    TEXT_RELATED_TRADES = ENGLISH.TEXT_RELATED_TRADES,
    TEXT_ABOUT_INFO = ENGLISH.TEXT_ABOUT_INFO
  } = LanguageData;

  return (
    <Card className="pagelist-content" sx={{ p: 2 }}>
      <Typography variant="h6"> {TEXT_ABOUT_INFO}</Typography>
      {!tradeDetails?.description && tradeNames?.length === 0 && relatedTradeNames?.length === 0 ? (
        <Box className="empty-data-card">
          <Emptydata
            icon={<ConstructionIcon className="emptydata-icon" />}
            firstText={TEXT_NO_INFO_TRADE}
          />
        </Box>
      ) : (
        <Box sx={{ paddingBottom: "5px" }}>
          {tradeDetails?.description && (
            <Stack sx={{ marginTop: "5px" }}>
              <Typography>{tradeDetails?.description}</Typography>
            </Stack>
          )}
          {tradeNames?.length > 0 && (
            <Stack
              style={{
                marginTop: "5px",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px 10px"
              }}
              direction="row"
              spacing={0}>
              <Typography style={{ color: "grey" }}>{TEXT_ALSO_KNOWN_AS}</Typography>
              <Typography>
                {tradeNames?.map((val, i) => {
                  return tradeNames?.length === i + 1 ? val?.name : `${val?.name}, `;
                })}
              </Typography>
            </Stack>
          )}
          {relatedTradeNames?.length !== 0 && (
            <Stack
              style={{
                marginTop: "2%",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px 10px"
              }}
              direction="row"
              spacing={0}>
              <Typography style={{ color: "grey" }}>{TEXT_RELATED_TRADES}</Typography>
              <Typography>
                {relatedTradeNames?.map((val, i) => {
                  return relatedTradeNames?.length === i + 1
                    ? val?.relatedWithTradeName
                    : `${val?.relatedWithTradeName}, `;
                })}
              </Typography>
            </Stack>
          )}
        </Box>
      )}
    </Card>
  );
};

export default TradeAboutSection;
